const PermissionService = (permissions) => {
	return {
		getUsersList () {
			function find(value){return value.alias=='get_backoffice_v1_users';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		createUser () {
			function find(value){return value.alias=='post_backoffice_v1_users';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		editUser () {
			function find(value){return value.alias=='put_backoffice_v1_users';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		
		getOrders () {
			function find(value){return value.alias=='get_backoffice_v1_order';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		ordersExport () {
			function find(value){return value.alias=='get_backoffice_v1_order_export';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		
		getOrder () {
			function find(value){return value.alias=='get_backoffice_v1_order_:id';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		editOrder () {
			function find(value){return value.alias=='put_backoffice_v1_order_:id';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		
		getActiveDeals () {
			function find(value){return value.alias=='get_backoffice_v1_deals_active';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		exportActiveDeals () {
			function find(value){return value.alias=='get_backoffice_v1_deals_active-export';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		
		getCloseDeals () {
			function find(value){return value.alias=='get_backoffice_v1_deals_closed';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		exportCloseDeals () {
			function find(value){return value.alias=='get_backoffice_v1_deals_closed-export';}
			if(permissions?.findIndex(find) !== -1) return true
		},

		//accounts
		getAccountsList () {
			function find(value){return value.alias=='get_backoffice_v1_trading_account';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		exportAccounts () {
			function find(value){return value.alias=='get_backoffice_v1_trading_account_export';}
			if(permissions?.findIndex(find) !== -1) return true
		},

		//clientslist
		getClientsList () {
			function find(value){return value.alias=='get_backoffice_v1_client';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		exportClients () {
			function find(value){return value.alias=='get_backoffice_v1_client_export';}
			if(permissions?.findIndex(find) !== -1) return true
		},

		//client
		getClientInfoById () {
			function find(value){return value.alias=='get_backoffice_v1_client_:id';}
			if(permissions?.findIndex(find) !== -1) return true
		},		
		getComment () {
			function find(value){return value.alias=='get_backoffice_v1_comment_:id';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		addComment () {
			function find(value){return value.alias=='post_backoffice_v1_comment';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		archiveAccount () {
			function find(value){return value.alias=='post_backoffice_v1_client_archive';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		activeAccount () {
			function find(value){return value.alias=='post_backoffice_v1_client_activate';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		getAccountByClientId () {
			function find(value){return value.alias=='get_backoffice_v1_trading_account_:id';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		getTransactionOrderByClientId () {
			function find(value){return value.alias=='get_backoffice_v1_transaction_order_client_:id';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		getActiveDealsByClientId () {
			function find(value){return value.alias=='get_backoffice_v1_deals_active_by_client_:id';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		getHistoryDealsByClientId () {
			function find(value){return value.alias=='get_backoffice_v1_deals_closed_by_client_:id';}
			if(permissions?.findIndex(find) !== -1) return true
		},
		canAccessClientDetails () {
			const permissionsToCheck = [
				'get_backoffice_v1_client_:id',
				'get_backoffice_v1_comment_:id',
				'get_backoffice_v1_trading_account_:id',
				'get_backoffice_v1_transaction_order_client_:id',
				'get_backoffice_v1_deals_active_by_client_:id',
				'get_backoffice_v1_deals_closed_by_client_:id'
			];

			return permissions?.some(permission => 
				permissionsToCheck.includes(permission.alias)
			) || false;
		}
	}
};

export default PermissionService;
